export default __webpack_public_path__ + "static/media/ServiceActivator-DarkBackground.ebefb251.png";